module.exports = __webpack_public_path__ + "img/spa2.4095da04.jpg";